/**
 * Labstep
 *
 * @module components/Entity/Action/Print
 * @desc Action to navigate to a print view
 */

import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { navigation } from 'labstep-web/services/navigation';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import type { EntityActionPrintProps } from './types';

export const EntityActionPrint: React.FC<EntityActionPrintProps> = ({
  entity,
  history,
  actionComponentProps,
}) => {
  const params = entity ? { id: entity.id } : undefined;
  const to = `${entity.entityName}_print` as const;
  const pathname = navigation.get(to, params);
  return (
    <ActionComponent
      dataCy="components/Entity/Action/Print"
      type="option"
      onClick={() => history.push(pathname)}
      text="Print"
      icon="print"
      {...actionComponentProps}
    />
  );
};

export default withRouter(EntityActionPrint);
